import React from 'react';
import BlocBuilder from "bloc-builder-react";
import $ from 'jquery';

import AppBloc from "./blocs/AppBloc";
import SwipeScreen from "../SwipeScreen";
import HomeRoom from "./components/HomeRoom";
import House from "./components/House";
import { AppBlocContext } from "./AppBlocContext";
import { API } from "./handler/ApiHandler";
import { ToastContainer, toast, Slide } from 'react-toastify';

class App extends React.Component {
    constructor( props ) {
        super(props);

        this.bloc = new AppBloc();
    }

    componentDidMount() {
        console.log("hi");
    }

    render() {
        return <AppBlocContext.Provider value={this.bloc}>
            <BlocBuilder
                subject={this.bloc.getSubject()}
                builder={( snapshot ) => {
                    let state = snapshot.data;
                    return <div className="container">
                        <HomeRoom state={state} appBloc={this.bloc}/>
                        <House state={state} ref={this.bloc.roomRef}/>
                        <ToastContainer
                            position="bottom-center"
                            autoClose={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            transition={Slide}
                        />
                    </div>;
                }}
            >

            </BlocBuilder>
        </AppBlocContext.Provider>;
    }
}

export default App;
